import Mentions from './src/Mentions';
import Option from './src/Option';

Mentions.Option = Option;

export default Mentions;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-mentions/index.js
// module id = null
// module chunks = 